<template>
  <div class="am_index BIM_index">
    <template v-if="!isShowDetail">
      <div class="back_div" v-if="!isBIMpath">
        <div class="back_div_left">
          <Button icon="ios-arrow-back"></Button>
          <Dropdown @on-click="clickMenu">
            <a href="javascript:void(0)">
              <span>{{
                isShowArchiveList ? "Archive" : "Asset Information"
              }}</span>
              <Icon type="md-menu" />
            </a>
            <DropdownMenu slot="list">
              <DropdownItem
                :selected="!isShowArchiveList"
                name="Asset Information"
                >Asset Information</DropdownItem
              >
              <DropdownItem name="BIM-AM Viewer">BIM-AM Viewer</DropdownItem>
              <DropdownItem name="Archive" :selected="isShowArchiveList"
                >Archive</DropdownItem
              >
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="back_div_right">
          <Dropdown @on-click="clickSettingMenu">
            <Button type="text">
              <i class="mdi mdi-cog-outline"> </i>
              <span>Setting</span>
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem name="Asset System">Asset System</DropdownItem>
              <DropdownItem name="Asset Type">Asset Type</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
      <div
        class="show_search_div"
        :class="switchSearch ? 'showSearch' : 'hideSearch'"
      >
        <div class="search_left">
          <div class="am_button_div">
            <div class="am_left" v-if="!isBIMpath">
              <Button
                type="text"
                @click="addAsset"
                class="addAsset_btn"
                v-show="!isShowArchiveList"
                >Add Asset</Button
              >
              <Modal
                v-model="isAddAsset"
                :title="!isEdit ? 'Add Asset' : 'Edit Asset'"
                :width="1341"
                class="asset_modal"
              >
                <add-asset
                  v-if="isAddAsset"
                  :systemList="systemList"
                  :typeList="typeList"
                  :isAddAsset="isAddAsset"
                  :isAdd="isAdd"
                  :isEdit="isEdit"
                  :isEditAsset="isEditAsset"
                  :deviceDetailsObj="deviceDetailsObj"
                  @isAddSuccess="isAddSuccess"
                ></add-asset>
                <div slot="footer">
                  <Button
                    type="primary"
                    size="small"
                    @click="!isEdit ? addAssetFn() : editAssetFn()"
                    >{{ !isEdit ? "Add" : "Save" }}
                  </Button>
                </div>
              </Modal>
              <Dropdown @on-click="selectBatch" v-show="!isShowArchiveList">
                <span>Batch Operation</span>
                <DropdownMenu slot="list">
                  <DropdownItem name="add">Batch Add</DropdownItem>
                  <DropdownItem name="edit">Batch modify</DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <Modal
                v-model="showBatchModal"
                :title="isAddBatch ? addBatchTitle : editBatchTitle"
                :width="batchWidth"
              >
                <div class="batchModalContent">
                  <div class="batchModalContent_left">
                    <div class="content_div">
                      1.Please export the template first. (If you already have a
                      template, skip this step)
                    </div>
                    <div
                      class="downloadTemplateBtn"
                      @click="downloadTemplateFun"
                    >
                      <a href="javascript:void(0)"
                        >Asset Template download [.xlsx]</a
                      >
                    </div>
                    <div class="content_div">
                      2. Please fill in the template according to the rules.
                    </div>
                    <div class="content_div">3. Upload file to add assets.</div>
                    <div class="uploadAsset">
                      <div class="uploadIcon">
                        <Icon type="ios-cloud-upload" />
                      </div>
                      <div class="uploadContent">
                        Click or drag files here to upload asset
                        information[.xlsx]
                      </div>
                    </div>
                  </div>
                  <div class="batchModalContent_right" v-if="!isAddBatch">
                    <Table
                      stripe
                      :columns="columns2"
                      :data="data2"
                      size="small"
                      max-height="360"
                    ></Table>
                  </div>
                </div>

                <div slot="footer">
                  <Button type="primary">Close</Button>
                </div>
              </Modal>
              <Button
                type="text"
                class="exportAsset_btn"
                @click="exportAssetFun"
                >Export Asset Info</Button
              >
            </div>
            <div class="am_right">
              <Button
                class="square_btn"
                :type="switchSearch ? 'primary' : 'default'"
                @click="switchSearchBtn"
              >
                <i class="mdi mdi-feature-search"></i>
              </Button>
              <Button class="square_btn" @click="refreshAssetListFn">
                <i class="mdi mdi-refresh"></i>
              </Button>
              <Input
                v-model.trim="keyWords.Name"
                search
                enter-button
                placeholder="name, description, rfid"
                @on-search="searchAssetList"
                @on-clear="clearAssetList"
              />
            </div>
          </div>
          <div class="button_div" v-if="idsArr.length > 0 && !isBIMpath">
            <div style="float: left; line-height: 42px; margin-left: 12px">
              {{ idsArr.length }} Selected
            </div>
            <Tooltip
              placement="top"
              max-width="500"
              v-show="!isShowArchiveList"
            >
              <Button
                class="warn_btn"
                type="text"
                @click="changheighlight(true)"
                >Highlight</Button
              >
              <div slot="content">
                <a href="javascript:void(0)"
                  >The highlighted asset will be put to the top.</a
                >
              </div>
            </Tooltip>
            <Button
              class="warn_btn"
              type="text"
              @click="changheighlight(false)"
              v-show="!isShowArchiveList"
              >Unhighlight</Button
            >
            <Tooltip
              placement="top"
              max-width="500"
              v-show="!isShowArchiveList"
            >
              <Button class="error_btn" type="text" @click="deleteSelete"
                >Delete</Button
              >
              <div slot="content">
                <a href="javascript:void(0)">Delete all selected assets.</a>
              </div>
            </Tooltip>
            <Button class="primary_btn" type="text" @click="showArchiveModal">{{
              isShowArchiveList ? "Unarchive" : "Archive"
            }}</Button>
          </div>
          <!-- 删除modal -->
          <Modal v-model="isSureDelete" title="Delete Assets"
            ><div class="deleteModalContent">
              The data CANNOT be recovered after delection.Please confirm to
              continue.
            </div>
            <div slot="footer">
              <Button size="large" @click="cancelBtn">Cancel</Button>
              <Button type="error" size="large" @click="deleteSeleteFn"
                >Confirm</Button
              >
            </div>
          </Modal>
          <!-- 存档modal -->
          <Modal
            v-model="isShowArchive"
            :width="654"
            :title="isShowArchiveList ? 'Unarchive Assets' : 'Archive Assets'"
            ><div class="archiveModalContent">
              {{
                isShowArchiveList
                  ? "Please confirm to unarchive this asset."
                  : "Archived assets can be restored from archive list."
              }}
            </div>
            <div slot="footer">
              <Button size="large" @click="cancelBtn">Cancel</Button>
              <Button type="primary" size="large" @click="ArchiveFn"
                >Confirm</Button
              >
            </div>
          </Modal>
          <!-- setting modal -->
          <SettingModal
            :showModalValue="showModalValue"
            :isShowSettingModal="isShowSettingModal"
            :systemList="systemList"
            :typeList="typeList"
            @closeModal="closeModal"
          ></SettingModal>
          <div class="am_table_div">
            <Card :padding="0" :shadow="false">
              <Table
                stripe
                ref="indexTable"
                :columns="columns1"
                :data="data1"
                :loading="isloading"
                :row-class-name="highlightName"
                @on-selection-change="selectFn"
                @on-row-click="oneRowClickFun"
                @on-select-cancel="cancelFn"
              ></Table>
            </Card>
          </div>
          <div class="paging">
            <Page
              :total="pageTotal"
              show-sizer
              show-elevator
              show-total
              @on-change="changePage"
              @on-page-size-change="changePageSize"
            />
          </div>
        </div>
        <div class="search_right">
          <Card>
            <div class="search_title">More filters</div>
            <Select
              placeholder="Building"
              :disabled="searchMoreLoading"
              v-model="keyWords.locationBuildingIds"
              multiple
              class="m_p"
              v-if="showBuilding"
            >
              <Option
                v-for="(item, index) in locationBuildingArr"
                :key="index"
                :value="item.locationId"
              >
                {{ item.locationName }}
              </Option>
            </Select>
            <Select
              placeholder="Floor"
              :disabled="searchMoreLoading"
              v-model="keyWords.locationFloorIds"
              multiple
              class="m_p"
              v-if="showFloor"
            >
              <Option
                v-for="(item, index) in locationFloorArr"
                :key="index"
                :value="item.locationId"
              >
                {{ item.locationName }}
              </Option>
            </Select>
            <Select
              placeholder="Room"
              :disabled="searchMoreLoading"
              v-model="keyWords.locationRoomIds"
              multiple
              class="m_p"
              v-if="showRoom"
            >
              <Option
                v-for="(item, index) in locationRoomArr"
                :key="index"
                :value="item.locationId"
              >
                {{ item.locationName }}
              </Option>
            </Select>

            <Divider />
            <Select
              placeholder="System"
              :disabled="searchMoreLoading"
              v-model="keyWords.SystemIds"
              multiple
            >
              <Option
                v-for="(item, index) in systemList"
                :key="index"
                :value="item.id"
              >
                {{ item.name }}
              </Option>
            </Select>
            <Select
              placeholder="Type"
              :disabled="searchMoreLoading"
              v-model="keyWords.TypeIds"
              multiple
              class="m_p"
            >
              <Option
                v-for="(item, index) in typeList"
                :key="index"
                :value="item.id"
              >
                {{ item.name }}
              </Option>
            </Select>
            <Select
              placeholder="Loaction"
              :disabled="searchMoreLoading"
              v-model="keyWords.LocationIds"
              multiple
              class="m_p"
            >
              <Option value="location">Location</Option>
            </Select>
            <Select
              placeholder="Status"
              clearable
              :disabled="searchMoreLoading"
              multiple
              class="m_p"
            >
              <Option value="All">All</Option>
              <Option value="Normal">Normal</Option>
              <Option value="Fault">Fault</Option>
              <Option value="Disabled">Disabled</Option>
            </Select>
            <Button
              @click="searchAssetList"
              :loading="searchMoreLoading"
              type="primary"
              long
              icon="md-search"
              class="m_p"
            >
            </Button>
          </Card>
        </div>
      </div>
    </template>
    <!-- <Drawer
      :title="deviceDetailsObj.name"
      v-model="showDeviceDrawer"
      width="500"
      :mask-closable="false"
    > -->
    <template v-else>
      <Tabs v-model="curTabsValue" type="card" @on-click="insightTabs">
        <TabPane name="Information" label="Information">
          <device-details
            v-if="isShowDetail"
            :deviceDetailsObj="deviceDetailsObj"
          ></device-details>
        </TabPane>
        <TabPane name="Insight" label="Insight">
          <div class="insight_img">
            <img src="../../public/image/Insight_image.png" />
          </div>
        </TabPane>
        <TabPane name="Maintenance" label="Maintenance" :disabled="false">
          <div class="insight_img">
            <img src="../../public/image/Maintenance_image.png" />
          </div>
        </TabPane>
        <Button
          class="transparent_btn"
          @click="returnTabsFun"
          slot="extra"
          type="default"
        >
          <i class="mdi mdi-arrow-u-left-top"></i>
        </Button>
      </Tabs>
    </template>
    <!-- </Drawer> -->
  </div>
</template>
<script>
import apiRoutes from "@/config/API_ROUTER";
import SettingModal from "../components/SettingModal";
import AddAsset from "../components/AddAsset";
import DeviceDetails from "../components/DeviceDetails";

export default {
  data() {
    return {
      isShowDetail: false,
      curTabsValue: "Information",
      curTabs: "Information",
      batchWidth: 660,
      /*  临时数据  start */
      columns2: [
        {
          title: "id",
          key: "id",
        },
        {
          title: "Asset Name",
          key: "Asset Name",
        },
        {
          title: "Location BIM",
          key: "Location BIM",
        },
      ],
      data2: [
        {
          id: "system1",
          "Asset Name": "A1",
          "Location BIM": "A1",
        },
      ],
      /* end */
      columns1: [
        // {
        //   type: "selection",
        //   width: 60,
        //   align: "center",
        // },
        {
          title: "Asset Name",
          key: "name",
        },
        {
          title: "System",
          key: "systemName",
        },
        {
          title: "Location",
          key: "locationName",
        },
        {
          title: "Description",
          key: "description",
          tooltip: true,
        },
        {
          title: "Status",
          // key: "status",
          render: (h, params) => {
            const val = params.row.status;
            let color = "";
            switch (val.toLowerCase()) {
              case "normal":
                color = "#00A870";
                break;
              case "fault":
                color = "#ED7B2F";
                break;
              default:
                color = "#4A4A4A";
                break;
            }
            return h(
              "div",
              {
                style: {
                  color,
                },
              },
              val
            );
          },
        },
        {
          title: "Action",
          key: "action",
          width: 94,
          align: "center",
          render: (h, params) => {
            const lightStatus = params.row.highlight;
            let lightH = null;
            if (lightStatus) {
              lightH = h(
                "DropdownItem",
                {
                  props: {
                    name: "Unhighlight",
                  },
                },
                "Unhighlight"
              );
            } else {
              lightH = h(
                "DropdownItem",
                {
                  props: {
                    name: "Highlight",
                  },
                },
                "Highlight"
              );
            }
            if (!this.isShowArchiveList) {
              return h("div", [
                h("i", {
                  class: "mdi mdi-crosshairs-gps",
                  style: {
                    marginRight: "15px",
                    color: "#ed4014",
                    "font-size": "16px",
                    cursor: "pointer",
                  },
                  on: {
                    click: (event) => {
                      event.stopPropagation();
                      this.postBIMbtn(params);
                    },
                  },
                }),
                h("i", {
                  class: "mdi mdi-eye",
                  style: {
                    color: "gray",
                    "font-size": "16px",
                    cursor: "pointer",
                  },
                  on: {
                    click: (event) => {
                      event.stopPropagation();
                      this.deviceDrawerbtn(params.row);
                    },
                  },
                }),
                h("i", {
                  class: "mdi mdi-border-color",
                  style: {
                    marginRight: "15px",
                    color: "#ED7B2F",
                    "font-size": "16px",
                    cursor: "pointer",
                    display: this.isBIMpath ? "none" : "inline-block",
                  },

                  on: {
                    click: (event) => {
                      event.stopPropagation();
                      this.showEditModal(params);
                    },
                  },
                }),

                h(
                  "Dropdown",
                  {
                    attrs: {
                      trigger: "hover",
                      "stop-propagation": true,
                    },
                    style: {
                      display: this.isBIMpath ? "none" : "inline-block",
                    },
                    on: {
                      "on-click": (e) => {
                        this.selectDropItemFn(e, params);
                        // console.log(params);
                      },
                    },
                  },
                  [
                    h("i", {
                      class: "mdi mdi-dots-horizontal",
                      style: {
                        marginRight: "15px",
                        color: "#0976F5",
                        "font-size": "16px",
                        cursor: "pointer",
                      },
                      on: {
                        click: (event) => {
                          event.stopPropagation();
                        },
                      },
                    }),
                    h(
                      "DropdownMenu",
                      {
                        slot: "list",
                      },

                      [
                        lightH,
                        h(
                          "DropdownItem",
                          {
                            props: {
                              name: "Archive",
                            },
                          },
                          "Archive"
                        ),
                        h(
                          "DropdownItem",
                          {
                            props: {
                              name: "Delete",
                            },
                          },
                          "Delete"
                        ),
                      ]
                    ),
                  ]
                ),
              ]);
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    border: "none",
                    color: "#0976F5",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.isShowArchive = true;
                      this.idsArrs = [];
                      this.idsArrs.push(params.row.id);
                      this.isArchiveAsset = true;
                    },
                  },
                },
                "Unarchive"
              ),
            ]);
          },
        },
      ],
      data1: [],
      switchSearch: false,
      systemList: [],
      typeList: [],
      searchMoreLoading: false,
      isAddAsset: false,
      showDeviceDrawer: false,
      isAdd: false,
      deviceDetailsObj: {},
      // 关键字搜索
      keyWords: {
        projectId: "2d3919b5-98f8-4cb0-99f6-08d9dbfc1b76",
        Name: "",
        SystemIds: [],
        TypeIds: [],
        LocationIds: [],
        Status: [],
        PageSize: 10,
        PageIndex: 1,
        isArchive: false,
        locationBuildingIds: [],
        locationFloorIds: [],
        locationRoomIds: [],
        bimid: 0,
      },
      locationBuildingArr: [],
      locationFloorArr: [],
      locationRoomArr: [],
      showBuilding: false,
      showFloor: false,
      showRoom: false,
      isEdit: false,
      isEditAsset: false,
      pageTotal: 0,
      isloading: false,
      // 批量
      idsArr: [],
      // 单行
      idsArrs: [],
      isSureDelete: false,
      showBatchModal: false,
      // 区分batch的操作
      isAddBatch: false,
      // 不同操作batch时不同的样式
      addBatchTitle: "Add asset in batches",
      editBatchTitle: "Modify asset in batches",
      // 是否展示存档
      isShowArchive: false,
      isArchiveAsset: false,
      // 高亮
      ishighlightAsset: false,
      // 展示存档table
      isShowArchiveList: false,
      // setting Modal
      showModalValue: "",
      isShowSettingModal: false,
      // 判断是否来自BIM
      isBIMpath: false,
    };
  },
  methods: {
    init() {
      this.keyWords.projectId =
        this.$route.query.projectId || "2d3919b5-98f8-4cb0-99f6-08d9dbfc1b76";
      const pathStr = this.$route.path;

      if (pathStr.includes("/BIMindex")) {
        this.isBIMpath = true;
      } else {
        this.isBIMpath = false;
      }
      this.idsArr = [];
      this.idsArrs = [];
      this.getSystemFun();
      this.getTypeFun();
      this.searchAssetList();
      this.getLocation();
    },
    returnTabsFun() {
      this.isShowDetail = false;
    },
    insightTabs(name) {
      // // console.log(name);
      switch (name) {
        case "Maintenance":
          /* this.$Message.info("Not Open");
          setTimeout(() => {
            this.curTabsValue = this.curTabs;
          }, 300); */
          break;

        default:
          // this.curTabs = name;
          break;
      }
    },
    postBIMbtn(params) {
      // console.log(params.row.bimid);
      if (params.row.bimid) {
        // 向父vue页面发送信息
        window.parent.postMessage(
          {
            cmd: "amdata",
            params: params.row,
          },
          "*"
        );
      }
    },
    getLocation() {
      const url = apiRoutes.Location;
      this.$http.get(url).then((res) => {
        // // console.log(res);
        this.showBuilding = false;
        this.showRoom = false;
        this.showFloor = false;
        const { data } = res.data;
        if (res.data.message === "Succeed") {
          for (let i = 0; i < data.length; i += 1) {
            if (data[i].locationLevelName === "Building") {
              this.showBuilding = true;
              this.locationBuildingArr = data[i].listData;
            }
            if (data[i].locationLevelName === "Room") {
              this.showRoom = true;
              this.locationRoomArr = data[i].listData;
            }
            if (data[i].locationLevelName === "Floor") {
              this.showFloor = true;
              this.locationFloorArr = data[i].listData;
            }
          }
        }
      });
    },
    exportAssetFun() {
      const url = apiRoutes.Export;
      this.$http
        .post(url, this.keyWords)
        .then((res) => {
          // window.open(res.request.responseURL);
          // // console.log(typeof res.data);
          // console.log(res);

          // excel 的 MIME 格式为 application/vnd.ms-excel
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          // 创建a链接 href链接地址 download为下载下来后文件的名称
          const aa = document.createElement("a");
          aa.href = URL.createObjectURL(blob);
          aa.innerHTML = "aaa";
          aa.download = "aaa.xlsx";
          aa.style.display = "none"; // 隐藏a标签 直接调用a标签的点击事件
          document.body.appendChild(aa);
          aa.click();
        })
        .catch(() => {
          // console.log(e);
        });
    },
    downloadTemplateFun() {
      const url = apiRoutes.DownloadTemplate;
      window.open(url);
    },
    // 选择菜单
    clickMenu(name) {
      // // console.log(name);
      switch (name) {
        case "Archive":
          this.isShowArchiveList = true;
          this.searchAssetList();
          break;
        case "Asset Information":
          this.isShowArchiveList = false;
          this.searchAssetList();
          break;
        default:
          break;
      }
    },
    searchMore() {
      this.searchMoreLoading = true;
      setTimeout(() => {
        this.searchMoreLoading = false;
      }, 2000);
    },
    getSystemFun() {
      const url = apiRoutes.SystemAttr;
      this.$http
        .get(url, {
          params: {
            projectId: this.keyWords.projectId,
          },
        })
        .then((res) => {
          // console.log(res);
          if (res.data.message === "Succeed") {
            this.systemList = res.data.data;
          } else {
            this.systemList = [];
          }
        })
        .catch(() => {
          // console.log(e);
        });
    },
    getTypeFun() {
      const url = apiRoutes.TypeAttr;
      this.$http
        .get(url, {
          params: {
            projectId: this.keyWords.projectId,
          },
        })
        .then((res) => {
          // console.log(res);
          if (res.data.message === "Succeed") {
            this.typeList = res.data.data;
          } else {
            this.typeList = [];
          }
        })
        .catch(() => {
          // console.log(e);
        });
    },
    switchSearchBtn() {
      this.switchSearch = !this.switchSearch;
      // if (this.switchSearch) {
      //   document.getElementsByClassName("show_search_div")[0].className =
      //     "show_search_div test";
      // } else {
      //   document.getElementsByClassName("show_search_div")[0].className =
      //     "show_search_div";
      // }
    },
    addAsset() {
      this.isEdit = false;
      this.isAddAsset = true;
    },
    addAssetFn() {
      this.isAdd = true;
    },
    deviceDrawerbtn(row) {
      this.isShowDetail = false;
      if (row && row.id) {
        this.showDeviceDrawer = true;
        this.isShowDetail = true;
        const url = apiRoutes.Asset;
        this.$http.get(`${url}/${row.id}`).then((res) => {
          // console.log(res);
          if (res.data.message === "Succeed") {
            this.deviceDetailsObj = JSON.parse(JSON.stringify(res.data.data));
          }
        });
      }
    },
    searchAssetList() {
      this.isloading = true;
      this.data1 = [];
      const url = apiRoutes.AssetQuery;
      const query = {};
      if (this.isShowArchiveList) {
        this.keyWords.isArchive = true;
      } else {
        this.keyWords.isArchive = false;
      }
      Object.keys(this.keyWords).forEach((key) => {
        if (this.keyWords[key]) {
          const isArr = this.keyWords[key] instanceof Array;
          if (isArr) {
            if (this.keyWords[key].length === 0) {
              // 如果是数组，并且长度为0，就跳过循环
              return;
            }
          }
          // 有内容的时候才加上
          query[key] = this.keyWords[key];
        }
      });
      // console.log(query);
      this.$http.post(url, query).then((res) => {
        if (res.data.message === "Succeed") {
          const tempArr = res.data.data.list;
          // console.log(tempArr);
          const arr = [];
          for (let i = 0; i < tempArr.length; i += 1) {
            arr.push(tempArr[i]);
          }
          Object.entries(arr).forEach(([, _v]) => {
            const v = _v;
            if (this.idsArr.includes(v.id)) {
              // eslint-disable-next-line no-underscore-dangle
              v._checked = true;
            }
          });
          this.data1 = arr;
          this.pageTotal = res.data.data.total;
          // // console.log(this.pageTotal);
          setTimeout(() => {
            // this.idsArr = [];
            this.idsArrs = [];
            this.isloading = false;
            this.pageCurrent = this.keyWords.PageIndex;
          }, 500);
        }
      });
    },
    clearAssetList() {
      this.keyWords = {
        Name: "",
        bimid: "",
        SystemIds: [],
        TypeIds: [],
        Status: [],
        PageSize: 10,
        PageIndex: 1,
        isArchive: false,
        locationBuildingIds: [],
        locationFloorIds: [],
        locationRoomIds: [],
      };
      this.searchAssetList();
    },
    refreshAssetListFn() {
      this.keyWords.Name = "";
      this.keyWords.SystemIds.splice(0);
      this.keyWords.TypeIds.splice(0);
      this.keyWords.Status.splice(0);
      this.keyWords.locationBuildingIds.splice(0);
      this.keyWords.locationFloorIds.splice(0);
      this.keyWords.locationRoomIds.splice(0);
      this.keyWords.bimId = "";
      this.keyWords.PageIndex = 1;
      this.init();
    },
    editAssetFn() {
      this.isEditAsset = true;
      this.isAdd = false;
    },
    isAddSuccess(value) {
      if (value) {
        this.isAddAsset = false;
        this.init();
      }
    },
    showEditModal(params) {
      this.isEdit = true;
      this.isAddAsset = true;
      const url = apiRoutes.Asset;
      this.$http.get(`${url}/${params.row.id}`).then((res) => {
        // // console.log(res);
        if (res.data.message === "Succeed") {
          this.deviceDetailsObj = JSON.parse(JSON.stringify(res.data.data));
        }
      });
      // // console.log(row);
    },
    changePage(index) {
      this.keyWords.PageIndex = index;
      this.searchAssetList();
    },
    changePageSize(size) {
      this.keyWords.PageSize = size;
      this.searchAssetList();
    },
    // 高亮
    highlightName(row) {
      // console.log(index);
      if (row.highlight) {
        return "highlightClass";
      }
      return "";
    },
    selectDropItemFn(name, params) {
      switch (name) {
        case "Highlight":
          this.idsArrs = [];
          this.ishighlightAsset = true;
          this.idsArrs.push(params.row.id);
          this.changheighlight(true);
          break;
        case "Unhighlight":
          this.idsArrs = [];
          this.ishighlightAsset = true;
          this.idsArrs.push(params.row.id);
          this.changheighlight(false);
          break;
        case "Archive":
          this.isShowArchive = true;
          this.idsArrs = [];
          this.idsArrs.push(params.row.id);
          this.isArchiveAsset = true;

          break;
        case "Delete":
          this.idsArrs = [];
          this.idsArrs.push(params.row.id);
          this.isDeleteId = true;
          this.isSureDelete = true;
          break;
        default:
          break;
      }
    },
    // 存档
    ArchiveFn() {
      const url = apiRoutes.Archive;
      let ids = [];
      let isArchive = false;
      if (this.isArchiveAsset) {
        ids = JSON.parse(JSON.stringify(this.idsArrs));
      } else {
        ids = JSON.parse(JSON.stringify(this.idsArr));
      }
      if (this.isShowArchiveList) {
        isArchive = false;
      } else {
        isArchive = true;
      }
      // // console.log(ids);
      const row = {
        ids,
        isArchive,
      };
      this.$http.put(url, row).then((res) => {
        if (res.data.message === "Succeed") {
          this.isShowArchive = false;
          this.init();
        }
      });
    },

    // 多选高亮
    changheighlight(status) {
      // // console.log(this.idsArr);
      const url = apiRoutes.Highlight;
      let ids = [];
      if (this.ishighlightAsset) {
        ids = JSON.parse(JSON.stringify(this.idsArrs));
      } else {
        ids = JSON.parse(JSON.stringify(this.idsArr));
      }

      const row = {
        ids,
        isHighlight: status,
      };
      this.$http.put(url, row).then((res) => {
        // console.log(res);
        if (res.data.message === "Succeed") {
          this.init();
          this.ishighlightAsset = false;
        }
      });
    },
    // 选中勾选
    selectFn(selection) {
      // // console.log(selection, "++++");
      const arr = [];
      Object.entries(selection).forEach(([, v]) => {
        arr.push(v.id);
      });
      this.idsArr = [...new Set(this.idsArr.concat(arr))];
    },
    cancelFn(selection, row) {
      // console.log(selection, row);
      this.idsArr.splice(this.idsArr.indexOf(row.id), 1);
    },
    oneRowClickFun(data) {
      // console.log(data, index);
      const params = {
        row: data,
      };
      this.postBIMbtn(params);
    },
    deleteSelete() {
      this.isSureDelete = true;
      this.isDeleteId = false;
    },
    // 批量删除
    deleteSeleteFn() {
      const url = apiRoutes.Asset;
      let ids = [];
      if (this.isDeleteId) {
        ids = JSON.parse(JSON.stringify(this.idsArrs));
      } else {
        ids = JSON.parse(JSON.stringify(this.idsArr));
      }
      // // console.log(ids);
      this.$http.delete(url, { data: { ids } }).then((res) => {
        // // console.log(res);
        if (res.data.message === "Succeed") {
          this.isSureDelete = false;
          this.init();
        }
      });
    },
    cancelBtn() {
      this.isSureDelete = false;
      this.isShowArchive = false;
    },
    // 展示batch的modal
    selectBatch(name) {
      this.showBatchModal = false;
      // console.log(name);
      switch (name) {
        case "add":
          this.uploadAssetUrl = apiRoutes.ImportAdd;
          this.isAddBatch = true;
          this.batchWidth = 700;
          break;

        case "edit":
          this.uploadAssetUrl = apiRoutes.ImportEdit;
          this.isAddBatch = false;
          this.batchWidth = 700;
          break;
        default:
          break;
      }
      this.showBatchModal = true;
    },
    // 展示存档的modal
    showArchiveModal() {
      this.isShowArchive = true;
      this.isArchiveAsset = false;
    },
    // setting Btn
    clickSettingMenu(name) {
      this.showModalValue = name;
      this.isShowSettingModal = true;
    },
    // 监听modal
    closeModal(value) {
      if (value) {
        this.isShowSettingModal = false;
        this.showModalValue = "";
      }
    },
    getBIMData() {
      const url = apiRoutes.AssetQuery;
      const query = {};
      Object.keys(this.keyWords).forEach((key) => {
        if (this.keyWords[key]) {
          const isArr = this.keyWords[key] instanceof Array;
          if (isArr) {
            if (this.keyWords[key].length === 0) {
              // 如果是数组，并且长度为0，就跳过循环
              return;
            }
          }
          // 有内容的时候才加上
          query[key] = this.keyWords[key];
        }
      });
      // // console.log(query);
      this.$http.post(url, query).then((res) => {
        if (res.data.message === "Succeed") {
          const tempArr = res.data.data.list;
          // console.log(tempArr);
          this.keyWords.bimid = 0;
          this.deviceDrawerbtn();
          if (tempArr && tempArr.length > 0) {
            this.deviceDrawerbtn(tempArr[0]);
          }
        }
      });
    },
    handleMessage(event) {
      if (event && event.type === "message") {
        const { data } = event;
        // console.log(data);
        const str = data.params.floorObj;
        if (str) {
          const obj = JSON.parse(str);
          // console.log(obj);
          const arrId = obj.id;
          if (arrId.length > 0) {
            this.keyWords.locationFloorIds = arrId;
            this.init();
          }
          /* let value = {
            entityid: "3",
            parentid: null,
            id: ["179515bf-0cfe-48c1-d241-08da42171f98"],
            name: "3F",
            model: ["1230_TKP2B_ARC_3F", "1230_TKP2B_MVAC_3F"],
            floorid: [
              "81add520-b485-4131-848d-e1e1a6157b26/1.0.0/5/1230_TKP2B_ARC_3F.ifc.unityab",
              "26f4692b-b71f-4bee-978f-9203d497f7cf/1.0.0/5/1230_TKP2B_MVAC_3F.ifc.unityab",
            ],
            children: [
              {
                entityid: "3/1",
                parentid: "3",
                name: "ARC",
                level: 1,
                tId: "ztree_3467547106_21",
                parentTId: "ztree_3467547106_20",
                open: false,
                isParent: false,
                zAsync: true,
                isFirstNode: true,
                isLastNode: false,
                isAjaxing: false,
                checked: false,
                checkedOld: false,
                nocheck: false,
                chkDisabled: false,
                halfCheck: false,
                check_Child_State: -1,
                check_Focus: false,
                isHover: false,
                editNameFlag: false,
              },
              {
                entityid: "3/2",
                parentid: "3",
                name: "MVAC",
                level: 1,
                tId: "ztree_3467547106_22",
                parentTId: "ztree_3467547106_20",
                open: false,
                isParent: false,
                zAsync: true,
                isFirstNode: false,
                isLastNode: true,
                isAjaxing: false,
                checked: false,
                checkedOld: false,
                nocheck: false,
                chkDisabled: false,
                halfCheck: false,
                check_Child_State: -1,
                check_Focus: false,
                isHover: false,
                editNameFlag: false,
              },
            ],
            level: 0,
            tId: "ztree_3467547106_20",
            parentTId: null,
            open: false,
            isParent: true,
            zAsync: true,
            isFirstNode: false,
            isLastNode: false,
            isAjaxing: false,
            checked: false,
            checkedOld: false,
            nocheck: false,
            chkDisabled: false,
            halfCheck: false,
            check_Child_State: 0,
            check_Focus: false,
            isHover: true,
            editNameFlag: false,
          }; */
        }
      }
    },
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener("message", this.handleMessage);
  },
  computed: {
    bimId() {
      return this.$route.query.bimId;
    },
    projectId() {
      return this.$route.query.projectId;
    },
  },
  watch: {
    bimId(bimid) {
      // console.log(bimid);
      this.keyWords.bimid = bimid;
      this.getBIMData();
    },
    projectId() {
      this.init();
    },
  },
  components: {
    AddAsset,
    DeviceDetails,
    SettingModal,
  },
};
</script>
<style lang="less">
.insight_img {
  // height: 660px;
  padding-right: 6px;
  height: 725px;
  overflow: auto;
  img {
    // height: 100%;
    display: block;
    width: 100%;
    object-fit: contain;
  }
}
.am_index.BIM_index {
  background: transparent;
  padding: 0;

  .back_div {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ivu-dropdown {
      margin-left: 16px;
    }
    .ivu-dropdown-menu {
      margin: 0 20px;
      .ivu-dropdown-item {
        border-radius: 4px;
        position: relative;
        &.ivu-dropdown-item-selected,
        &:hover {
          &::before {
            content: "";
            display: block;
            position: absolute;
            left: -20px;
            top: 4px;
            width: 4px;
            height: 24px;
            background: #0177fd;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
          }
        }
      }
    }
  }
  .show_search_div {
    // display: flex;
    // justify-content: space-between;
    position: relative;
    overflow-x: hidden;
    min-height: 550px;
    padding-top: 4px;
    .search_left {
      width: 100%;
    }
    .search_right {
      position: absolute;
      top: 0;
      right: -300px;
      padding-left: 16px;
      width: 294px;
      .m_p {
        margin-top: 16px;
      }
    }
  }
  //加入动画class
  .showSearch.show_search_div {
    .search_left {
      padding-right: 300px;
      transition: padding 1s;
    }
    .search_right {
      right: 0px;
      transition: right 1s;
    }
  }
  //隐藏动画
  .hideSearch.show_search_div {
    .search_left {
      transition: 1s;
    }
    .search_right {
      right: -300px;
      transition: right 1s;
    }
  }
  .am_button_div {
    display: flex;
    justify-content: end;
    .am_right {
      display: flex;
      .ivu-btn {
        margin-right: 10px;
      }
    }
    .am_left {
      .addAsset_btn,
      .exportAsset_btn {
        &:hover {
          background: #0976f5;
          color: #fff;
        }
      }
    }
  }
  .am_table_div {
    padding-top: 16px;
  }
  .asset_modal {
    .ivu-modal {
      top: 0;
    }
  }
  .ivu-modal-footer {
    border-top: none;
  }
  .paging {
    padding-top: 20px;
    padding-bottom: 20px;
    width: 100%;
    text-align: center;
  }
  .highlightClass {
    td:first-child {
      position: relative;
      &::before {
        content: "";
        width: 3px;
        position: absolute;
        height: 100%;
        left: 0;
        top: 0;
        background: #00a870;
      }
    }
  }
  .button_div {
    padding-top: 10px;
    text-align: right;
    .warn_btn {
      color: #ed7b2f;
      &:hover {
        background-color: #ed7b2f;
        color: #fff;
      }
    }
    .error_btn {
      color: #e34d59;
      &:hover {
        background-color: #e34d59;
        color: #fff;
      }
    }
    .primary_btn {
      color: #0976f5;
      &:hover {
        background-color: #0976f5;
        color: #fff;
      }
    }
  }
  .deleteModalContent {
    font-size: 22px;
    line-height: 32px;
    color: #e34d59;
    padding: 24px 60px;
    text-align: justify;
  }
  .batchModalContent {
    height: 100%;
    padding: 16px 20px 30px 16px;
    font-size: 16px;
    line-height: 23px;
    display: flex;
    justify-content: space-between;
    .batchModalContent_left {
      flex: 1;
      .content_div {
        margin-bottom: 10px;
      }
      .downloadTemplateBtn {
        margin: 14px 20px;
        background: #f2f2f2;
        border-radius: 2px;
        width: 250px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
      }
      .uploadAsset {
        cursor: pointer;
        width: 100%;
        padding: 47px 104px 42px 104px;
        border: 1px dashed #cfcfcf;
        border-radius: 2px;
        .uploadIcon {
          text-align: center;
          font-size: 34px;
          color: #0976f5;
        }
        .uploadContent {
          text-align: center;
        }
      }
    }
    .batchModalContent_right {
      flex: 1;
      margin-left: 20px;
    }
  }
  .footerBtn {
    display: flex;
    justify-content: space-around;
  }
  .archiveModalContent {
    font-size: 22px;
    text-align: center;
    color: #0976f5;
  }
  .transparent_btn {
    background: #333;
    border: none;
    color: #fff;
  }
}
</style>
